import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AlertMessage from "./AlertMessage";
import {
  Container,
  Card,
  CardHeader,
  Button,
  Row,
  Form,
  FormInput,
  NavLink,
  CardBody,
} from "shards-react";
import { connect } from "react-redux";
import PasswordStrengthBar from "react-password-strength-bar";
import { updateUserData } from "../utils/redux/actions";
import Loading from "./Loading";
import { useFormHook, useRequestHook } from "../utils/hooks/hooks";

/**
 * Export a component to be used in login, forgot-password and etc. pages.
 */

const CompleteForm = (props) => {
  const { handleRequest } = useRequestHook();
  const [errMsg, setErrMsg] = useState();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [redirectToSso, setRedirectToSso] = useState(false);
  const [passwordState, setPasswordState] = useState(0);
  const [alertDuration, setAlertDuration] = useState(5000);

  const handleChangePassword = (score) => {
    setPasswordState(score);
  };

  useEffect(() => {
    if (props.failCode === "0" || props.failCode === "1") {
      setErrMsg("Login mit SSO nicht möglich!");
    }
    if (props.failCode === "2") {
      setAlertDuration(8000);
      setErrMsg(
        "Konto noch nicht in Synop Angelegt. Bitte kontaktieren Sie ihre Admin!"
      );
    }
  }, [props.failCode]);

  const { values, handleSubmit, handleChange } = useFormHook(() => {
    /**
     * Define a callback to handle the submit form.
     */

    if (props.showCopiedPasswordField && passwordState <= 1) {
      setErrMsg("Passwort stärke zu gering.");
      return;
    }

    if (
      props.showCopiedPasswordField &&
      values.copied_password !== values.password
    ) {
      setErrMsg("Erneut eingegebenes Passwort nicht identisch.");
      return;
    }

    setLoading(true);
    setErrMsg(undefined);
    handleRequest("post", props.requestPath, values, async (response) => {
      if (response && response.ssoRedirect) {
        setLoading(false);
        setRedirectToSso(true);
        window.location.href = response.ssoRedirect;
        return;
      } else if (props.name === "Login") {
        if (response === "Change password.") {
          window.location.href = "/changePassword";
        } else {
          if (response) {
            props.dispatch(updateUserData(response));
            window.location.href = props.afterLoginRedirect;
          } else {
            setLoading(false);
            setErrMsg("E-Mail oder Passwort falsch!");
          }
        }
      } else if (props.name === "Passwort vergessen") {
        if (response === true) {
          window.location.href = "/login";
        } else {
          setLoading(false);
          setErrMsg("Die E-mail existiert nicht.");
        }
      } else if (props.name === "Passwort ändern") {
        if (response === true) {
          window.location.href = "/login";
        } else {
          setLoading(false);
          setErrMsg("Es ist ein Fehler aufgetreten.");
        }
      } else {
        if (response) {
          props.dispatch(updateUserData(response));
        } else {
          setLoading(false);
          setErrMsg("Keine Antwort vom Server erhalten.");
        }
      }
    });
  });
  const emailField = (
    /**
     * Define a variable for the password field
     * that will appear on the login page.
     */
    <>
      <Row className="mb-3" form>
        <label className="w-100 text-center" htmlFor="emailAddress">
          Email
        </label>
        <FormInput
          id="emailAddress"
          type="email"
          placeholder="Email"
          required
          onChange={(e) => handleChange(e.target.id, e.target.value)}
        />
      </Row>
    </>
  );
  const oldPasswordField = (
    /**
     * Define a variable for the password field
     * that will appear on the login page.
     */
    <>
      <Row className="mb-3" form>
        <label className="w-100 text-center" htmlFor="old_password">
          Altes Passwort
        </label>
        <FormInput
          id="old_password"
          type="password"
          autoComplete="false"
          placeholder="Altes Passwort"
          required
          onChange={(e) => handleChange(e.target.id, e.target.value)}
        />
      </Row>
    </>
  );
  const passwordField = (
    /**
     * Define a variable for the password field
     * that will appear on the login page.
     */
    <>
      <Row className="mb-3" form>
        <label className="w-100 text-center" htmlFor="password">
          Passwort
        </label>
        <FormInput
          id="password"
          type="password"
          autoComplete="false"
          placeholder="Passwort"
          required
          onChange={(e) => {
            handleChange(e.target.id, e.target.value);
            setPassword(e.target.value);
          }}
        />
      </Row>
    </>
  );
  const copiedPasswordField = (
    /**
     * Define a variable for the copied password field
     * that will appear on the login page.
     */
    <>
      <Row className="mb-3" form>
        <label className="w-100 text-center" htmlFor="copied_password">
          Passwort erneut eingeben
        </label>
        <FormInput
          id="copied_password"
          type="password"
          autoComplete="false"
          placeholder="Passwort"
          required
          onChange={(e) => handleChange(e.target.id, e.target.value)}
        />
      </Row>
    </>
  );

  return (
    <>
      {loading ? (
        <Loading style={{ height: "100vh" }} />
      ) : (
        <Container
          fluid
          className="container d-flex flex-column align-items-center"
          style={{ minHeight: "100vh", gap: "1.5rem", position: "relative" }}
        >
          {errMsg && (
            <div
              className="w-100 d-flex justify-content-center"
              style={{
                position: "absolute",
                top: "1.5rem",
                left: 0,
                zIndex: 10,
              }}
            >
              <AlertMessage
                alertDuration={alertDuration}
                autoDismiss
                alertMessage={errMsg}
                setErrMsg={setErrMsg}
                classes={redirectToSso ? "text-dark" : ""}
                background={redirectToSso ? "white" : "danger"}
              />
            </div>
          )}
          <Card className="p-3" small style={{ marginTop: "12.5vh" }}>
            <CardHeader className="border-bottom">
              <h2 className="text-center" style={{ color: "#0299B4" }}>
                {props.name}
              </h2>
            </CardHeader>
            <CardBody>
              {!redirectToSso && (
                <>
                  <Form className="text-center" onSubmit={handleSubmit}>
                    {!props.showEmailField && emailField}
                    {props.showOldPasswordField && oldPasswordField}
                    {/* The password field will be displayed only in the login page. */}
                    {props.showPasswordField && passwordField}
                    {props.showCopiedPasswordField && (
                      <PasswordStrengthBar
                        password={password}
                        scoreWords={[
                          "schwach",
                          "schwach",
                          "ok",
                          "gut",
                          "stark",
                        ]}
                        shortScoreWord="zu kurz"
                        onChangeScore={handleChangePassword}
                      />
                    )}
                    {props.showCopiedPasswordField && copiedPasswordField}
                    <Button theme="warning" type="submit">
                      {props.submitButton}
                    </Button>
                  </Form>
                  {props.goToButton && (
                    <NavLink
                      className="text-center"
                      tag={Link}
                      to={props.goToButton.to}
                    >
                      {props.goToButton.name}
                    </NavLink>
                  )}
                </>
              )}
            </CardBody>
          </Card>
        </Container>
      )}
    </>
  );
};

/**
 * Define mapStateToProps and return an empty Object.
 * Necessary for hassle-free functioning of redux.
 */
const mapStateToProps = () => ({});

export default connect(mapStateToProps)(CompleteForm); //Export component and connect it with redux.
